import React from 'react';
import { Star } from 'lucide-react';
import { TESTIMONIALS } from '../../data/mock';
import { SectionHeading } from '../shared';
import Reveal from '../Reveal';

function Card({ t }) {
  return (
    <div className="glass rounded-2xl p-6 w-[360px] shrink-0 card-hover">
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => <Star key={i} size={15} className="text-lime fill-lime" />)}
      </div>
      <p className="text-white/70 text-sm leading-relaxed mb-5">“{t.text}”</p>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-lime/20 flex items-center justify-center text-lime font-display font-bold">{t.name[0]}</div>
        <div>
          <p className="text-white text-sm font-semibold">{t.name}</p>
          <p className="text-white/50 text-xs">{t.role}</p>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const half = Math.ceil(TESTIMONIALS.length / 2);
  const row1 = TESTIMONIALS.slice(0, half);
  const row2 = TESTIMONIALS.slice(half);
  return (
    <section className="py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 mb-14">
        <Reveal>
          <SectionHeading center label="testimonianze" title="Cosa dicono" highlight="i nostri clienti" />
        </Reveal>
      </div>
      <div className="space-y-5">
        <div className="relative overflow-hidden">
          <div className="flex gap-5 w-max animate-marquee">
            {[...row1, ...row1].map((t, i) => <Card key={i} t={t} />)}
          </div>
        </div>
        <div className="relative overflow-hidden">
          <div className="flex gap-5 w-max animate-marquee-slow" style={{ animationDirection: 'reverse' }}>
            {[...row2, ...row2].map((t, i) => <Card key={i} t={t} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
